import { Box, Button, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  calculateDateRange,
  convertToMinutes,
} from "../../redux/actions/action";
import IndividualQuizCard from "./IndividualQuizCard";

export default function AllQuizzes({ quizzes, filter }) {
  const [loadMoreVisible, setLoadMoreVisible] = useState(true);
  const [visibleData, setVisibleData] = useState([]);
  console.log(quizzes, "all quizzes")
  useEffect(() => {
    if (quizzes) {
      setVisibleData(quizzes.slice(0, 12));
      if (quizzes.length <= 12) {
        setLoadMoreVisible(false);
      } else {
        setLoadMoreVisible(true);
      }
    }
  }, [quizzes]);

  const loadMoreHandler = () => {
    setVisibleData(quizzes.slice(0, visibleData.length + 12));
    if (visibleData.length + 12 >= quizzes.length) {
      setLoadMoreVisible(false);
    }
  };

  return (
    <Box
      w="100%"
      d="flex"
      flexWrap={["nowrap", "nowrap", "wrap", "wrap"]}
      flexDir={["column", "column", "row", "row"]}
      justifyContent="flex-start"
      alignItems="center"
      style={{ gap: "2.25rem" }}
    >
      {visibleData.length > 0 ? (
        visibleData.map((quiz) => (
          <IndividualQuizCard
            id={quiz.id}
            key={quiz.id}
            title={quiz.title}
            attemptsLeft={quiz["no_of_attempts_left"] ? Number(quiz["no_of_attempts_left"]) : null}
            date={quiz.start_date ? calculateDateRange(quiz.start_date, quiz.end_date.split(' ')[0]) : null}
            time={quiz.time_duration ? convertToMinutes(quiz.time_duration) : null}
            topicTitle={
              quiz.topic_id && quiz.topics.title
                ? quiz.topics.title
                : quiz.course_id && quiz.courses.title
                ? quiz.courses.title
                : null
            }
            topicImage={
              quiz.topic_id
                ? quiz.topics.cover_image
                : quiz.course_id
                ? quiz.courses.cover_image
                : null
            }
            filter = {filter}
          />
        ))
      ) : (
        <Text
          fontSize={["15px", "15px", "20px", "25px"]}
          fontWeight="700"
          style={{ fontFamily: "Mulish, sans-serif" }}
        >
          No Quizzes to display under the filter of {filter}!
        </Text>
      )}
      <Box width="100%" d="flex" justifyContent="center" alignItems="center">
        {loadMoreVisible && (
          <Button
            color="#00000099"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["12px", "14px", "16px", "18px"]}
            border="2px solid rgba(0, 0, 0, 0.1)"
            boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
            borderRadius="xl"
            py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
            px={["0.75rem", "1rem", "1.5rem", "2rem"]}
            m="2rem"
            bg="#ffffff"
            onClick={loadMoreHandler}
          >
            Load More...
          </Button>
        )}
      </Box>
    </Box>
  );
}
